<template>

    <div class="sdev-wizard-step-content">

        <!-- HEADER -->

        <div class="sdev-wizard-step-content-header">

            <div class="header-left">
                <h1>{{ title }}</h1>
                <p>{{ version }}</p>
            </div>

            <div class="header-right">
                Step {{ actualStepInFlow }} of {{ totalStepsInFlow }}
            </div>

        </div>

        <!-- IDENTITY STEP -->

        <div v-if="step === 'load_identities'">

            <label>Select Organization</label>

            <select v-model="selectedIdentity" class="sdev-select">
                <option disabled value="">Select organization</option>
                <option v-for="id in identities" :key="id.key" :value="id.key">
                    {{ id.name }}
                </option>
            </select>

            <button class="sdev-button" @click="selectIdentity">
                Next
            </button>

        </div>

        <!-- TEMPLATE STEP -->

        <div v-if="step === 'template'">

            <label>Select Template</label>

            <select v-model="selectedTemplate" class="sdev-select">
                <option disabled value="">Select template</option>
                <option v-for="t in templates" :key="t.key" :value="t.key">
                    {{ t.label }}
                </option>
            </select>

            <button class="sdev-button" @click="startTemplate">
                Start Wizard
            </button>

        </div>

        <!-- FINALIZE -->

        <div v-if="step === 'finalize'">

            <h3>Blueprint Plan</h3>

            <button v-if="!preview" class="sdev-button" @click="$emit('preview')">
                Generate Plan
            </button>

            <div v-if="previewLoading">
                Generating preview...
            </div>

            <div v-if="preview">

                <div class="sdev-card">

                    <h4>Identities</h4>

                    <ul>
                        <li v-for="i in preview.identities" :key="i.key">
                            {{ i.key }} ({{ i.status }})
                        </li>
                    </ul>

                </div>

                <div class="sdev-card">

                    <h4>Relations</h4>

                    <ul>
                        <li v-for="r in preview.relations" :key="r.parent + r.child">
                            {{ r.parent }} → {{ r.child }}
                        </li>
                    </ul>

                </div>

                <div class="sdev-card">

                    <h4>Secrets</h4>

                    <ul>
                        <li v-for="s in preview.secrets" :key="s.identity + s.type">
                            {{ s.identity }} – {{ s.type }}
                        </li>
                    </ul>

                </div>

                <button class="sdev-button sdev-bg-surface-elevated" @click="$emit('execute')">
                    Execute Blueprint
                </button>

            </div>

        </div>

        <!-- FORM STEP -->

        <form v-else-if="fields.length" @submit.prevent="submit">

            <div v-for="f in fields" :key="f.name" class="sdev-form-field">

                <label>{{ f.name }}</label>

                <input v-if="f.type === 'text'" v-model="form[f.name]" class="sdev-input" required />

                <input v-else-if="f.type === 'password'" type="password" v-model="form[f.name]" class="sdev-input"
                    required />

            </div>

            <button class="sdev-button">
                Next
            </button>

        </form>

    </div>

</template>
<script setup>

import { ref, computed } from "vue"

const props = defineProps({
    step: String,
    data: Object,
    templates: Array,
    identities: Array,
    context: Object,
    preview: Object,
    previewLoading: Boolean,
    totalStepsInFlow: Number,
    actualStepInFlow: Number
})

const emit = defineEmits([
    "next",
    "start",
    "preview",
    "execute"
])

const selectedTemplate = ref(null)
const selectedIdentity = ref(null)
const form = ref({})

const title = computed(() => props.data?.template_name || "Wizard")
const version = computed(() => props.data?.version || "")

const fields = computed(() => {

    if (!props.data?.wizard) return []

    const index = props.actualStepInFlow - 1

    return props.data.wizard[index]?.fields || []
})

function startTemplate() {

    if (!selectedTemplate.value) return

    emit("start", selectedTemplate.value)
}

function selectIdentity() {

    if (!selectedIdentity.value) return

    emit("next", {
        organization: selectedIdentity.value
    })
}

function submit() {

    emit("next", form.value)

}

</script>
